module.exports = __webpack_public_path__ + "static/img/fitness16.d3772b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/fitness16.png
// module id = AZjb
// module chunks = 1